// extracted by mini-css-extract-plugin
module.exports = {"container":"LazyFrame_container__2gdPv","loaded":"LazyFrame_loaded__2PyS-","frame":"LazyFrame_frame__3YYLI","preview":"LazyFrame_preview__3oBHg","icon":"LazyFrame_icon__2FpPK"};